/* eslint-disable eqeqeq */
import React, { useState } from "react";
import CustomTooltip from "../../components/CustomTooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faEnvelope, faEye, faTrash } from "@fortawesome/free-solid-svg-icons";
import JointAccountDetailsPopup from "./JointAccountDetailsPopup";
import moment from "moment";
import { CalendarCheck, SearchCheck } from "lucide-react";

const JointAccountActionButton = ({
  id,
  org,
  setEdit,
  setOnlyKyc,
  setJointAccountId,
  toggleShowAddEditJointAccount,
  trustId,
  jointAccount,
  toggleShowDelete,
  used,
  handleSendEmail,
  kycAction,
  amlCTFEnable,
}) => {
  const [showView, setShowView] = useState(false);

  const toggleShowModal = () => {
    setShowView(!showView);
  };

  const getNextReviewDate = () => {
    let assessmentDate = jointAccount?.kyc?.risk_assessment?.assessment_date;
    let risk = jointAccount?.kyc?.risk;
    if (!assessmentDate) return "N/A";

    let yearsToAdd = 0;

    if (risk == 0) yearsToAdd = 3;
    else if (risk == 1) yearsToAdd = 1;
    else if (risk == 2) yearsToAdd = 2;
    else return "N/A";

    return moment(assessmentDate, "DD-MM-YYYY")
      .add(yearsToAdd, "years")
      .format("DD-MM-YYYY");
  };

  return (
    <>
      {kycAction ? (
        <span className="flex items-center gap-2 justify-center">
          {jointAccount?.kyc?.risk_assessment && (
            <>
              <CustomTooltip
                message={
                  <div>
                    <p>
                      Assessment Date:{" "}
                      {jointAccount?.kyc?.risk_assessment?.assessment_date}
                    </p>
                    <p>Next Review Date: {getNextReviewDate()}</p>
                  </div>
                }
              >
                <CalendarCheck size={16} />
              </CustomTooltip>
              <span>/</span>
            </>
          )}
          <CustomTooltip message={"Onboarding"}>
            <SearchCheck
              size={16}
              onClick={() => {
                setOnlyKyc(true);
                setEdit(true);
                toggleShowAddEditJointAccount();
                setJointAccountId(id);
              }}
            />
          </CustomTooltip>
        </span>
      ) : (
        <span className="flex items-center gap-2 justify-center">
          {amlCTFEnable ? (
            <>
              {jointAccount?.contact?.email !== null ? (
                <CustomTooltip message={"Email"}>
                  <span>
                    <FontAwesomeIcon
                      icon={faEnvelope}
                      size="1x"
                      onClick={() => {
                        !jointAccount?.is_reversed && handleSendEmail(jointAccount?.id);
                      }}
                      className={`${
                        jointAccount?.is_reversed
                          ? "opacity-50 cursor-not-allowed "
                          : jointAccount?.consent_mail_sent
                            ? "text-green-600"
                            : ""
                      }`}
                    />
                  </span>
                </CustomTooltip>
              ) : (
                <CustomTooltip message={"Email address missing"}>
                  <span>
                    <FontAwesomeIcon
                      icon={faEnvelope}
                      size="1x"
                      disabled
                      className={"opacity-50 cursor-not-allowed"}
                    />
                  </span>
                </CustomTooltip>
              )}
              <span>/</span>
            </>
          ) : (
            <></>
          )}
          
          <CustomTooltip message={"View"}>
            <span>
              <FontAwesomeIcon
                onClick={toggleShowModal}
                icon={faEye}
                size="1x"
                data-toggle="modal"
                data-target="#clientDetail"
              />
            </span>
          </CustomTooltip>
          <span>/</span>
          <CustomTooltip message={"Edit"}>
            <span>
              <FontAwesomeIcon
                icon={faEdit}
                size="1x"
                onClick={() => {
                  setEdit(true);
                  toggleShowAddEditJointAccount();
                  setJointAccountId(id);
                }}
              />
            </span>
          </CustomTooltip>
          {used ? (
            <></>
          ) : (
            <>
              <span>/</span>
              <CustomTooltip message={"Delete"}>
                <span>
                  <FontAwesomeIcon
                    icon={faTrash}
                    size="1x"
                    onClick={() => {
                      setJointAccountId(id);
                      toggleShowDelete();
                    }}
                  />
                </span>
              </CustomTooltip>
            </>
          )}
        </span>
      )}
      {showView && (
        <JointAccountDetailsPopup
          showView={showView}
          jointAccountId={id}
          toggleShowModal={toggleShowModal}
          setShowView={setShowView}
        />
      )}
    </>
  );
};

export default JointAccountActionButton;
